<template>
  <div class="clearfix" v-if="!pageLoad">
    <div class="spinner-grow text-danger" style="width: 3rem; height: 3rem;margin-top:25vh; margin-left:42%; margin-bottom:5vh" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
  <div v-if="pageLoad" class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25">
      <div class="d-sm-flex align-items-center">
        <input
              v-model="searchQuery"
              type="text"
              class="form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16"
              :placeholder="$t('tokens.search')"
              @input="page = 1"
            />
      </div>
      <div class="d-flex align-items-center">
        <button
          class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0"
          type="button"
          style="background-color: #EB9355;"
          @click="refreshTokens"
        >
          {{ $t('tokens.refresh') }}
          <i class="flaticon-refresh position-relative ms-5 fs-12"></i>
        </button>
      </div>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      

      <div v-if="revokeError" class="alert alert-danger">
        {{ revokeError }}
      </div>

      <div class="table-responsive">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0">
                {{ $t('tokens.code') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0">
                {{ $t('tokens.user') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0">
                {{ $t('tokens.email') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                {{ $t('tokens.type') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                {{ $t('tokens.deviceId') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                {{ $t('tokens.ipAddress') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                {{ $t('tokens.createdAt') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                {{ $t('tokens.expiresAt') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                {{ $t('tokens.status') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(tok) in paginatedTokens" :key="tok.code">
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                <span class="text-truncate d-inline-block" style="max-width: 120px;" :title="tok.code">
                  {{ tok.code.substring(0, 8) }}...
                </span>
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ tok.user?.code || '-' }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ tok.user?.email || '-' }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                <span class="badge" :class="tok.user?.type === 'API' ? 'text-outline-primary' : 'text-outline-secondary'">
                  {{ tok.user?.type || '-' }}
                </span>
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                <span class="text-truncate d-inline-block" style="max-width: 100px;" :title="tok.deviceId">
                  {{ tok.deviceId ? tok.deviceId.substring(0, 10) + '...' : '-' }}
                </span>
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ tok.ipAddress || '-' }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ tok.createdAt ? formatDateFr(new Date(tok.createdAt)) : '-' }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ tok.expiresAt ? formatDateFr(new Date(tok.expiresAt)) : '-' }}
              </td>
              <td class="shadow-none lh-1 fw-medium">
                <span class="badge text-outline-success" v-if="!tok.revokedAt">{{ $t('tokens.active') }}</span>
                <span class="badge text-outline-danger" v-else>{{ $t('tokens.revoked') }}</span>
              </td>
              <td class="shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0">
                <div class="dropdown" v-if="!tok.revokedAt">
                  <button class="dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                    <i class="flaticon-dots"></i>
                  </button>
                  <ul class="dropdown-menu">
                    <li v-if="current_permissions('revoke_token')">
                      <a class="dropdown-item d-flex align-items-center" style="color: red;" href="javascript:void(0);" @click="confirmRevoke(tok)">
                        <i class="flaticon-pen lh-1 me-8 position-relative top-1"></i>
                        <span class="">{{ $t('tokens.revoke') }}</span>
                      </a>
                    </li>
                  </ul>
                </div>
                <span v-else class="text-muted">-</span>
              </td>
            </tr>
            <tr v-if="filteredTotal === 0">
              <td colspan="10" class="text-center text-muted py-20">
                {{ $t('tokens.noResults') || '-' }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-if="filteredTotal>0" class="pagination-area d-md-flex mt-15 mt-md-25 mb-0 justify-content-between align-items-center">
        <p v-if="filteredTotal>pageSize" class="mb-0 text-paragraph">
          {{ $t('tokens.showing') }} <span class="fw-bold">{{ showingFrom }}-{{ showingTo }}</span> {{ $t('tokens.outOf') }}
          <span class="fw-bold">{{ filteredTotal }}</span> {{ $t('tokens.results') }}
        </p>
        <p v-if="filteredTotal<=pageSize" class="mb-0 text-paragraph">
          {{ $t('tokens.showing') }} <span class="fw-bold">{{ filteredTotal }}</span> {{ $t('tokens.outOf') }}
          <span class="fw-bold">{{ filteredTotal }}</span> {{ $t('tokens.results') }}
        </p>
        <nav class="mt-15 mt-md-0">
          <ul class="pagination mb-0">
            <li v-if="(page-1)>0" class="page-item">
              <a class="page-link" @click="goToPage(page-1)" aria-label="Previous">
                <i class="flaticon-chevron-1"></i>
              </a>
            </li>
            <li v-for="(numPage) in numPages" :key="numPage" class="page-item">
              <a v-if="numPage==page" class="page-link active" href="#">{{ numPage }}</a>
              <a v-else class="page-link" @click="goToPage(numPage)">{{ numPage }}</a>
            </li>
            <li v-if="(page+1)<=numPages" class="page-item">
              <a class="page-link" @click="goToPage(page+1)" aria-label="Next">
                <i class="flaticon-chevron"></i>
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, onMounted, inject, watch } from "vue";
import axios from 'axios';
import router from '../../router/index';
import { useI18n } from "vue-i18n";
import { current_permissions } from '../../utils/permission';
import { checkSessionValidate } from '../../utils/function';

const backApi = inject('back');
const { t } = useI18n();

const token = ref<string | null>(localStorage.getItem('login_token'));
const pageLoad = ref(false);
const tokens = ref<any[]>([]);
const revokeError = ref('');
const loading = ref(false);

const searchQuery = ref('');
const page = ref(1);
const pageSize = 15;

function formatDateFr(value: Date | null): string {
  if (!value) return '-';
  const year = value.getFullYear();
  let month = value.getMonth() + 1;
  const monthStr = month < 10 ? '0' + month : String(month);
  let day = value.getDate();
  const dayStr = day < 10 ? '0' + day : String(day);
  const hours = String(value.getHours()).padStart(2, '0');
  const minutes = String(value.getMinutes()).padStart(2, '0');
  return dayStr + '/' + monthStr + '/' + year + ' ' + hours + ':' + minutes;
}

const filteredTokens = computed(() => {
  const q = searchQuery.value.trim().toLowerCase();
  if (!q) return tokens.value;

  return tokens.value.filter((item) => {
    const haystack = [
      item.code || '',
      item.user?.code || '',
      item.user?.email || '',
      item.user?.type || '',
      item.deviceId || '',
      item.ipAddress || '',
      item.createdAt ? formatDateFr(new Date(item.createdAt)) : '',
      item.expiresAt ? formatDateFr(new Date(item.expiresAt)) : '',
      item.revokedAt ? 'revoque' : 'actif',
    ]
      .join(' ')
      .toLowerCase();

    return haystack.includes(q);
  });
});

const filteredTotal = computed(() => filteredTokens.value.length);

const numPages = computed(() => Math.max(1, Math.ceil(filteredTotal.value / pageSize)));

const paginatedTokens = computed(() => {
  const start = (page.value - 1) * pageSize;
  return filteredTokens.value.slice(start, start + pageSize);
});

const showingFrom = computed(() => {
  if (filteredTotal.value === 0) return 0;
  return (page.value - 1) * pageSize + 1;
});

const showingTo = computed(() => {
  return Math.min(page.value * pageSize, filteredTotal.value);
});

function goToPage(target: number) {
  if (target < 1 || target > numPages.value) return;
  page.value = target;
}

watch(numPages, (max) => {
  if (page.value > max) page.value = max;
});


// Récupère une page de tokens depuis l'API (forme { data, pagination })
const fetchTokensPage = (targetPage: number) => {
  const url = `${backApi}/secure/token/sessions?page=${targetPage}`;

  return axios.get(url, {
    headers: {
      Authorization: `Bearer ${token.value}`,
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache, no-store'
    }
  });
};

const getTokens = async () => {
  try {
    const first = await fetchTokensPage(1);
    const collected: any[] = [...first.data.data];
    const totalPages = first.data.pagination.numPages;

    if (totalPages > 1) {
      const remainingRequests = [];
      for (let p = 2; p <= totalPages; p++) {
        remainingRequests.push(fetchTokensPage(p));
      }
      const results = await Promise.all(remainingRequests);
      results.forEach(r => collected.push(...r.data.data));
    }

    tokens.value = collected;
  } catch (error: any) {
    if (error.response) {
      if (error.response.status === 401) {
        router.push('/');
      }
      console.error('Error fetching tokens:', error.response.data);
    }
  }
};

const refreshTokens = () => {
  getTokens();
};

const confirmRevoke = (tok: any) => {
  revokeError.value = '';
  const ok = window.confirm(
    `${t('tokens.revokeMessage')}\n${t('tokens.user')}: ${tok.user?.email || '-'}`
  );
  if (ok) {
    revokeToken(tok);
  }
};

const revokeToken = (tok: any) => {
  loading.value = true;
  revokeError.value = '';

  axios.post(`${backApi}/secure/token/revoke`, {
    user: tok.user?.code
  }, {
    headers: {
      Authorization: `Bearer ${token.value}`,
      'Content-Type': 'application/json'
    }
  })
  .then(() => {
    getTokens();
  })
  .catch((error) => {
    if (error.response) {
      revokeError.value = error.response.data?.message || t('tokens.revokeError');
      if (error.response.status === 401) {
        router.push('/');
      }
    } else {
      revokeError.value = t('tokens.revokeError');
    }
  })
  .finally(() => {
    loading.value = false;
  });
};

onMounted(async () => {
  checkSessionValidate(1);
  await getTokens();

  setTimeout(function () {
    pageLoad.value = true;
  }, 1000);
});
</script>

<style scoped>
.text-truncate {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.text-outline-primary {
  color: #0d6efd;
  background-color: rgba(13, 110, 253, 0.1);
  border: 1px solid #0d6efd;
}
.text-outline-secondary {
  color: #6c757d;
  background-color: rgba(108, 117, 125, 0.1);
  border: 1px solid #6c757d;
}
.text-outline-success {
  color: #198754;
  background-color: rgba(25, 135, 84, 0.1);
  border: 1px solid #198754;
}
.text-outline-danger {
  color: #dc3545;
  background-color: rgba(220, 53, 69, 0.1);
  border: 1px solid #dc3545;
}
</style>